import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export { StyledContainer };
